import { ComplianceSection } from './ComplianceSection';
const meta = {
    title: 'Features/AIChatWidget/ComplianceSection',
    component: ComplianceSection
};
export default meta;
export const Default = {};
